







































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import PlantPicker from "@/view/shared-components/PlantPicker.vue";
import Plant from "@/domainObjects/Plant";
import TicketService from "@/services/TicketService";
import WipTicket from "@/domainObjects/wip/WipTicket";
import Fields from "@/domainObjects/Fields";
import LoadingActions from "@/store/actions/loading";


@Component({
  name: 'WipTicketTable',
  components:{
    PlantPicker
  },
})
export default class WipTicketTable extends Vue {
  @Prop({required: false}) updatedTicket!: WipTicket;
  @Prop({required: false}) updatedTicketType!: string;

  @Watch('$route')
  onPropertyChanged(to, from){
    if (to.name === 'wip-tickets'){
      this.fetchWipTickets();
    }
  }

  private wipTickets:WipTicket[] = [];
  private allWipTickets:WipTicket[] = [];
  private fields:Fields[] = [];
  private activeTickets:number = 0;
  private currentPage:number = 0;
  private perPage:number = 0;
  private totalRows:number = 0;
  private filter:string = '';
  private hover:boolean = true;
  private pageOptions:number[] = [];
  private sortBy: string = '';
  private sortDesc: boolean;
  private isBusy = true;
  private unsecureServerUrl:string = '';
  private plant: Plant = new Plant();
  private tableLayout: boolean = false;
  private windowWidth: number = 0;
  private ticketsLoaded: boolean = false;

  constructor() {
    super();
    this.fetchWipTickets();
    this.unsecureServerUrl = TicketService.getUnsecureServerUrl();
    this.fields = [
      { key: 'wipTicketId', label: 'Ticket #', sortable: true, sortDirection: 'desc'},
      { key: 'productionOrderNum', label: 'Order Number', sortable: true, sortDirection: 'desc' },
      { key: 'qtyOnHold', label: 'Qty.', sortable: true, sortDirection: 'desc'},
      { key: 'materialDesc', label: 'Material Desc.', sortable: true, sortDirection: 'desc'},
      { key: 'comments', label: 'Required', sortable: true, sortDirection: 'desc'},
      { key: 'daysOpen', label: 'Days Open', sortable: true, sortDirection: 'desc' },
      { key: 'plant.desc', label: 'Plant', sortable: true, sortDirection: 'desc' },
      { key: 'actions', label: 'Options', sortable: false, sortDirection: 'desc' }
    ];
    this.currentPage = 1;
    this.perPage = 25;
    this.totalRows = this.wipTickets.length;
    this.filter = "";
    this.hover = true;
    this.pageOptions = [ 5, 10, 25, 50, 100 ];
    this.sortBy = 'wipTicketId';
    this.sortDesc = true;
  }

  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  destroyed(){
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize(){
    this.tableLayout = window.innerWidth < 992;
    this.windowWidth = window.innerWidth;
  }

  onFiltered( filteredItems ) {
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }

  fetchWipTickets() {
    this.$store.dispatch(LoadingActions.LOADING, true);
    this.wipTickets = [];
    this.isBusy = true;
    TicketService.getWipTickets().then((response) => {
      for ( let readWipTicket of response.data ) {
        let ticket = new WipTicket();
        ticket.initFromObject(readWipTicket);
        this.wipTickets.push(ticket);
      }
      this.allWipTickets = this.wipTickets;
      this.activeTickets = this.wipTickets.length;
      if (this.plant){
        this.filterByPlant(this.plant);
      }
      this.isBusy = false;
      this.ticketsLoaded = true;
      this.$store.dispatch(LoadingActions.LOADING, false);
    }).catch((error)=>{
    });
  }

  filterByPlant(value){
    if (value.code == 0){
      this.wipTickets = this.allWipTickets;
    } else {
      this.wipTickets = this.allWipTickets.filter(ticket => ticket.plant.code === value.code);
    }
    this.activeTickets = this.wipTickets.length;
    this.plant = value;
  }

  changeLayout(){
    this.tableLayout = !this.tableLayout;
  }

  addTicket(){
    // @ts-ignore
    this.$router.push({ name: 'add-wip-ticket', params: {plant: this.plant}})
  }

  forceRefresh(){
    //this.plant = new Plant();
    this.filter = "";
    this.fetchWipTickets();
  }
}

